
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-5690774f\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../node_modules/string-replace-loader/index.js??ref--9!../../node_modules/string-replace-loader/index.js??ref--10!../../node_modules/string-replace-loader/index.js??ref--11!../../node_modules/string-replace-loader/index.js??ref--12!./DemoEvent.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/string-replace-loader/index.js??ref--9!../../node_modules/string-replace-loader/index.js??ref--10!../../node_modules/string-replace-loader/index.js??ref--11!../../node_modules/string-replace-loader/index.js??ref--12!./DemoEvent.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5690774f\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/string-replace-loader/index.js??ref--9!../../node_modules/string-replace-loader/index.js??ref--10!../../node_modules/string-replace-loader/index.js??ref--11!../../node_modules/string-replace-loader/index.js??ref--12!./DemoEvent.vue"),
  /* scopeId */
  "data-v-5690774f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/DemoEvent.vue
// module id = 845
// module chunks = 0